import React from "react";
import Slider from "react-slick";
import get from "lodash/get";
import { Link, ResponsiveHeroImage, ReviewRating, LazyLoadImages } from "@quintype/components";
import { CollectionName } from "../basic/collection-name.js";
import { ImageFallback } from "../basic/image-fallback.js";
import { wrapCollectionLayout } from "@quintype/components";
import { collectionSection } from "./collection-layout-helper.js";
import { altTagOfHeroImages, isExternalStory, getCarousel } from "../../utils";

function FullscreenLinearGallerySliderBase({ collection, stories, config, associatedMetadata }) {
  const settings = {
    centerMode: true,
    centerPadding: "130px",
    slidesToShow: 3,
    autoplay: true,
    lazyLoad: true,
    onLazyLoad: () => {},
    autoplaySpeed: 5000,
    rtl: get(config, ["theme-attributes", "language_direction"]) === "right",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding: "20px",
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerPadding: "80px",
          slidesToShow: 1
        }
      }
    ]
  };
  const inlineStyle = {
    color: "#fff",
    marginBottom: "0"
  };
  const { show_collection_title: collectionName = true } = associatedMetadata;
  if (!stories) {
    return null;
  }

  const SliderWrapper = (
    <Slider {...settings} className="linear-gallery-slider__slides">
      {stories.map((story, index) => (
        <div key={`${story.id}-${index}`} className="linear-gallery-slider__slider-content">
          <SliderItem story={story} />
        </div>
      ))}
    </Slider>
  );

  const Slide = (
    <div className="single-slide linear-gallery-slider__slider-content">
      <SliderItem story={stories[0]} />
    </div>
  );

  return (
    <div className="linear-gallery-slider component-wrapper-fluid" data-test-id="linear-gallery-slider-component">
      <div className="linear-gallery-slider__heading">
        {collectionName ? (
          <CollectionName inlineStyle={inlineStyle} name={collection.name} type="large" section={collection} />
        ) : null}
      </div>
      {getCarousel(SliderWrapper, Slide)}
    </div>
  );
}

function SliderItem({ story }) {
  const isReviewStory = story["story-template"] === "review";
  return (
    <Link href={"/" + story.slug} externalLink={isExternalStory(story)}>
      {story["hero-image-s3-key"] ? (
        <figure className={`linear-gallery-slider__image--${story["story-template"]}`}>
          <LazyLoadImages>
            <ResponsiveHeroImage
              story={story}
              aspectRatio={[4, 3]}
              alt={altTagOfHeroImages(story)}
              defaultWidth={480}
              widths={[320, 480, 640]}
              imgParams={{ auto: ["format", "compress"], fit: "max" }}
              sizes="(max-width: 500px) 25vw, (max-width: 768px) 25vw, 25vw"
            />
          </LazyLoadImages>
        </figure>
      ) : (
        <ImageFallback />
      )}
      <p
        className="linear-gallery-slider__item-title"
        dangerouslySetInnerHTML={{ __html: story.headline }}
        data-test-id="fullscreen-linear-gallery-headline"
      />
      {isReviewStory && <ReviewRating value={get(story, ["metadata", "review-rating", "value"], "0")} />}
    </Link>
  );
}

export const FullscreenLinearGallerySlider = wrapCollectionLayout(FullscreenLinearGallerySliderBase);
